export const FILTER_SHOULD_BE_OPEN = 'should_be_open';
export const FILTER_CLOSE_TO_OPEN = 'close_to_open';
